export function addCurrent(webhook) {
    return {
        type: 'ADD_CURRENT_WEBHOOK',
        webhook,
    }
}

export function clearCurrent() {
    return {
        type: 'CLEAR_CURRENT_WEBHOOK',
    }
}
